import { h } from 'preact';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';

import Typography from '@mui/material/Typography';

import styles from '../global.css';

export default function LazyRpmSingleMetricCard(_props) {
  return (
    <Card sx={{ marginBottom: '20px' }}>
      <CardActions>
        <Typography variant="h5">
          <Skeleton width={240} />
        </Typography>

        <Skeleton sx={{ marginLeft: 'auto' }} width={360} height={48} />

        <Skeleton width={40} height={40} variant="circular" />
      </CardActions>
      <CardContent className={styles.goodUxHolder}>
        <Skeleton width="100%" height={250} variant="rounded" />
      </CardContent>
    </Card>
  );
}
